import React from 'react'

function heading() {
    return (
        <div>
            <h1 className="quiz-heading">QUIZ INSTRUCTION</h1>
            
        </div>
    )
}

export default heading;
